// extracted by mini-css-extract-plugin
export var checkbox = "_7b-0";
export var circle = "_7b-3";
export var horizontalContainer = "_7b-7";
export var sm = "_7b-5";
export var switch0 = "_7b-2";
export var switchDisabled = "_7b-8";
export var switchEnabled = "_7b-1";
export var textSwitchContainer = "_7b-9";
export var textSwitchOption = "_7b-a";
export var textSwitchOptionSelected = "_7b-b";
export var verticalContainer = "_7b-6";
export var xs = "_7b-4";